export default __webpack_public_path__ + "static/media/hr.3b73614d.svg";